import { Anchor } from '../Button/Button.js';
import * as S from './ServiceListItem.styles.js';
import { Border } from '@/components/Motion/Border/Border.js';
import { FadeUpInView } from '@/components/Motion/Fade/FadeUpInView/FadeUpInView.js';
import { type ServiceCardProps } from '@/components/ServiceCard/types.js';
import { getService } from '@/components/ServiceCard/utils.js';
import { WithSampleTag } from '@/components/WithSampleTag/WithSampleTag.js';
import { useHeadlineVariant } from '@/hooks/useHeadlineVariant.js';
import { useServiceNode } from '@/hooks/useResourceNode/useServiceNode.js';

type BorderProps = {
  readonly isLast: Boolean;
};

export const ServiceListItem = ({
  index,
  isLast,
  node,
}: BorderProps & Omit<ServiceCardProps, 'ctaButton'>) => {
  const {
    isContactForPricing,
    isFreeService,
    isVariableRate,
    priceWithInterval,
    timeline,
    typeWithTimeline,
  } = getService(node);
  const { anchorProps, href, isMock } = useServiceNode({ index, node });
  const headlineFontFamily = useHeadlineVariant();

  return (
    <S.Container>
      <Border />
      {isLast && <Border position="bottom" />}
      <S.Title
        as="h3"
        fontFamily={headlineFontFamily}
        variant="h2"
      >
        <WithSampleTag
          isMock={isMock}
          sampleType="service"
        >
          {node.title}
        </WithSampleTag>
      </S.Title>
      <S.DetailsContainer>
        <S.PricingContainer>
          {isContactForPricing ? (
            <S.StyledSmallcaps>Contact for Pricing</S.StyledSmallcaps>
          ) : isFreeService ? (
            <>
              <S.StyledSmallcaps translucent>Free</S.StyledSmallcaps>
              <S.StyledSmallcaps>{timeline}</S.StyledSmallcaps>
            </>
          ) : (
            <>
              {isVariableRate ? (
                <S.StyledSmallcaps translucent>Starting At</S.StyledSmallcaps>
              ) : null}
              <S.StyledSmallcaps>{priceWithInterval}</S.StyledSmallcaps>
              <S.StyledSmallcaps translucent>
                {typeWithTimeline}
              </S.StyledSmallcaps>
            </>
          )}
        </S.PricingContainer>
        <FadeUpInView delay={1}>
          <Anchor
            href={href}
            {...anchorProps}
            variant="inverted"
          >
            <S.StyledSmallcaps>View Service</S.StyledSmallcaps>
          </Anchor>
        </FadeUpInView>
      </S.DetailsContainer>
    </S.Container>
  );
};
